import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    selectionContainer: {
      display: 'flex',
      gap: 40,
      marginTop: 50,
      flexWrap: 'wrap',
      overflowY: 'auto',

      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        marginBottom: 40,
      },
    },
    heading: {
      textAlign: 'center',
      fontSize: 22,
      [theme.breakpoints.down('md')]: {
        fontSize: 18,
        marginTop: 10,
      },
    },
    helpText: {
      color: '#60718b',
    },
    primaryText: {
      width: 250,
      textAlign: 'center',
      [theme.breakpoints.down(960)]: {
        width: 'unset',
        margin: '0 10px',
      },
    },
    box: {
      height: 300,
      width: 300,
      border: '1px solid #2d343e',
      borderRadius: '8px !important',
      background: '#0c0f14',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0.5,
      [theme.breakpoints.down(960)]: {
        height: 190,
        width: 250,
      },

      '&:hover': {
        border: `1px solid ${COLORS.PRIMARY}`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '8px !important',
      },
    },
    boxActive: {
      opacity: 1,
      border: `1px solid ${COLORS.PRIMARY}`,
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
    },
  }),
);
